export class CourseObjective {
    id: number;
    sortOrder: number;
    description: string;
    displayOrder: number;

    constructor(data) {
        this.id = (data.eventObjective_pk ) ? parseInt(data.eventObjective_pk) : null
        this.sortOrder = String(data.display_order) ? parseInt(data.display_order) : null
        this.description = (data.description ) ? data.description : null
        this.displayOrder = (this.sortOrder != null) ? this.sortOrder + 1 : null
    }
}